module.exports = __webpack_public_path__ + "src/assets/img/second_icon_0.ce4d0263.svg";